export default __webpack_public_path__ + "static/media/about_last.6fdca9bf.png";